// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import FeaturedProducts from "@guestsupply/App/Components/Header/FeaturedProducts";
import FeaturedProductsCard from "@guestsupply/App/Components/Header/FeaturedProductsCard";
import MarketingSection from "@guestsupply/App/Components/Header/MarketingSection";
import loadFeaturedProducts from "@guestsupply/App/Handlers/XNG/FeaturedProducts";
import { CustomAppState } from "@guestsupply/App/Store/Reducers";
import { xScreen } from "@guestsupply/XDL/Utilities";
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import StyledWrapper, { getStyledWrapper } from "@insite/client-framework/Common/StyledWrapper";
import siteMessage from "@insite/client-framework/SiteMessage";
import updateProductInfo from "@insite/client-framework/Store/Components/ProductInfoList/Handlers/UpdateProductInfo";
import translate from "@insite/client-framework/Translate";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";
import LoadingSpinner, { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC, useEffect } from "react";
import { connect, ResolveThunks } from "react-redux";

interface BrandsAndSolutionsProps {
    image: string;
    content: string;
    title: string;
    detailPagePath: string;
    featuredProducts?: string;
}

type Props = BrandsAndSolutionsProps;

export interface BrandsAndSolutionsStyle {
    marketingWrapper?: InjectableCss;
}

export const brandsAndSolutionsStyles: BrandsAndSolutionsStyle = {};

const styles = brandsAndSolutionsStyles;

const BrandsAndSolutions: FC<Props> = ({ image, content, title, detailPagePath, featuredProducts }) => {
    const parentMenu = React.createRef<HTMLDivElement>();

    const { headerHeight } = useAppSelector(state => ({
        headerHeight: (state as CustomAppState).xHeader?.headerHeight,
    }));
    return (
        <StyledWrapper ref={parentMenu} {...styles.marketingWrapper} {...{ headerHeight }}>
            <MarketingSection image={image} title={title} content={content} detailPagePath={detailPagePath} />
            <FeaturedProducts productNumbers={featuredProducts || ""} />
        </StyledWrapper>
    );
};

export default BrandsAndSolutions;
